(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('episodeTemplate', episodeTemplate);

    function episodeTemplate() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * If provided, the campaign is within the scope of this clinic; otherwise it is an IHH campaign.
                 */
                clinic: '=',

                /**
                 * If in a clinic scope, the ID of the therapist user doing the editing.
                 */
                therapistId: '=',

                /**
                 * A function(campaignId, episodeTemplate) to create the new episode template.
                 */
                saveEpisodeTemplate: '=',

                /**
                 * A function(campaignId, episodeTemplateId, episodeTemplate) to update the existing episode template.
                 */
                updateEpisodeTemplate: '=',

                /**
                 * A function(campaignId, episodeTemplateId) to delete the existing episode template.
                 */
                removeEpisodeTemplate: '=',

                /**
                 * An object with methods to query, create, read, update, and delete campaign prescriptions.
                 */
                prescriptionsCrud: '=',

                /**
                 * An object with methods to query, create, read, update, and delete campaign resource materials.
                 */
                messagesCrud: '=',

                /**
                 * An object with methods to query, create, read, update, and delete campaign resource materials.
                 */
                resourceMaterialsCrud: '=',

                /**
                 * The episode template being edited or created.
                 */
                episodeModel: '=',

                /**
                 * If provided, a function(clinic, featureString) that answers whether the clinic has that feature flag enabled.
                 */
                hasClinicFeature: '=',

                /**
                 * If provided, an initialized config for choosing therapists; if not provided, no therapists can be assigned to the episode or messages.
                 */
                therapistConfig: '=',

                /**
                 * If provided, an initialized config for choosing associates to assign to the template; if not provided, no associates can be assigned.
                 */
                associateConfig: '=',

                /**
                 * If provided, an initialized chooser config for care groups; if not provided, no care groups can be assigned.
                 */
                careGroupConfig: '=',

                /**
                 * A chooser config already initialized for picking campaign prescription exercises.
                 */
                exercisesConfig: '=',

                /**
                 * A chooser config already initialized for picking campaign prescription exercise templates.
                 */
                exerciseTemplatesConfig: '=',

                /**
                 * A chooser config already initialized for picking campaign presription protocols.
                 */
                protocolsConfig: '=',

                /**
                 * An already initialized chooser config for resource materials.
                 */
                resourceMaterialsConfig: '=',

                /**
                 * Indicates whether the episode is a template, that is, only usable to create another episode template.
                 */
                isTemplate: '=',

                /**
                 * Indicates whether the template is read only.
                 */
                isReadOnly: '='
            },
            controller: 'EpisodeTemplateCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'episode-template/episode-template.tpl.html'
        };
    }
})();
